import styled from 'styled-components'

interface BillItemPopoverLayoutStyledProps {}

export const BillItemPopoverLayoutStyled = styled.div<BillItemPopoverLayoutStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  font-weight: ${(props) => props.theme.typography.fontWeightRegular};

  border-radius: ${(props) => props.theme.space.small}
    ${(props) => props.theme.space.small} 0 0;
  padding-top: ${(props) => props.theme.space.large};
  padding-left: ${(props) => props.theme.space.large};
  padding-right: ${(props) => props.theme.space.large};
  padding-bottom: ${(props) => props.theme.space.xlarge};
`
